/**
 * Created by mateo on 5/24/17.
 */

import { Identifier } from "typescript";


interface Categoria {
  id: number;
  ordenAgrupador?: number;
}

interface Curso {
  id: number;
  nickName?: string;
  nombre?: string;
  seccion?: number;
}

interface Materia {
  areaID?: number;
  id: number;
  nickName?: string;
  nombre?: string;
  orden?: number;
}

interface Ambito {
  id: number;
  nombre: string;
  ordenAgrupador?: number;
}

interface Tag {
  id: number;
  nombre: string;
}

interface isOn {
  up: boolean;
  same: boolean;
  down: boolean;
}

interface Conexion {
  isOn: isOn;
  selfColor: string;
}

export interface NivelCriterio {
  criterios: Criterio[];
  id: string | number;
  nickName: string;
  nombre: string;
  orden: string | number;
}

export interface Criterio {
  id: string | number;
  escala: any;
  escalaID: string | number;
  isConectado: boolean;
  isPristine: boolean;
  nivel: any;
  nivelID: string | number;
  niveles: NivelCriterio[];
  nombre: string;
  orden: string | number;
  idiomas: {id?: number, criterioId: number, idioma: string, nombre: string}[];
  metaData?: any;
}

export interface Version {
  id: number;
  majorVersion: string;
  minorVersion?: string;
  createdDate?: string;
  descEN?: string;
  descES?: string;
  descFR?: string;
}

export class Meta {
  public id: number;
  public categoriaID: number;
  public codigo: string;
  public majorVersion: string;
  public minorVersion: string;
  public order: number;
  public htmlES: string;
  public htmlEN: string;
  public htmlFR: string;
  public htmlIdioma: string;
  public txtES: string;
  public txtEN: string;
  public txtFR: string;
  public txtIdioma: string;
  public editores: any[];
  public tags: Tag[];
  public materias: Materia[];
  public ambitos: Ambito[];
  public cursos: Curso[];
  public categoria: Categoria;
  public criterios?: Criterio[];
  public criteriosDto?: Criterio[];
  public unidades: any;
  public metas: number[];
  public metasPadre: any;
  public metasHija: any;
  public metasHermana: any;
  public unidadesHijas: any;
  public isActive: boolean;
  public offset: any;
  public versiones: Version[];
  public versionId: number;
  public alumnosPendientes: any[];
  public criteriosIdiomasVista: any;
  public areas: any[];
  // Atributos de control
  public show = true;
  public isConnected: boolean;
  public isConOrig: boolean;
  public bulkSelected: boolean;
  public setBulk: boolean;
  public isSelected = false;
  public isOrderable = false;
  public indicadores: any;
  public selfColor: string;
  public conexion: Conexion;
  public conexionesActivas;
  public conexiones;
  public isEditable: boolean = false;
  public alumnos;

  constructor(json) {
    this.id = json.id;
    this.categoriaID = json.categoriaID;
    this.codigo = json.codigo;
    this.majorVersion = json.majorVersion;
    this.minorVersion = json.minorVersion;
    this.htmlES = json.htmlES;
    this.txtES = json.txtES;
    this.htmlEN = json.htmlEN;
    this.txtEN = json.txtEN;
    this.htmlFR = json.htmlFR;
    this.txtFR = json.txtFR;
    this.htmlIdioma = json.htmlIdioma;
    this.txtIdioma = json.txtIdioma;
    this.categoria = json.categoria;
    this.criterios = json.criterios || [];
    this.criteriosDto = json.criteriosDto || [];
    this.editores = json.editores;
    this.tags = json.tags;
    this.materias = json.materias;
    this.ambitos = json.ambitos;
    this.cursos = json.cursos || [];
    this.unidades = json.unidades;
    this.unidadesHijas = json.unidadesHijas || [];
    this.metas = json.metas || [];
    this.alumnosPendientes = json.alumnosPendientes || [];
    this.criteriosIdiomasVista = json.criteriosIdiomasVista || {};
    this.conexionesActivas = json.conexionesActivas || [];
    this.areas = json.areas || [];
    this.versiones = json.versiones || [];
    this.versionId = json.versionId;
    this.conexiones = json.conexiones || {
      status: {up: false, same: false, down: false},
      active: false,
      selfColor: '',
      activeColor: ''
    };
    if (json.metasPadre) {
      this.metasPadre = json.metasPadre.filter(function (elem, index, self) {
        return index == self.indexOf(elem);
      });
    } else {
      this.metasPadre = [];
    }
    if (json.metasHija) {
      this.metasHija = json.metasHija.filter(function (elem, index, self) {
        return index == self.indexOf(elem);
      });
      this.metasHija = [];
    }
    if (json.metasHermana) {
      this.metasHermana = json.metasHermana.filter(function (elem, index, self) {
        return index == self.indexOf(elem);
      });
      this.metasHermana = [];
    }

    this.offset = {left: 0, top: 0, height: 0, width: 0};

    this.isActive = json.isActive;

    this.show = true;
    this.isConnected = false;
    this.setBulk = false;
    this.indicadores = [];
    this.selfColor = '';
    this.conexion = {isOn: {up: false, same: false, down: false}, selfColor: ''};
    this.isEditable = ((typeof json.isEditable) == 'boolean' ? json.isEditable : false);

    this.isSelected = json.isSelected;
  }

  public getCodigo() {
    return this.codigo + '-' + this.id.toString();
  }
  public getVersionName(): string {
    return ' v' + this.majorVersion + '.' + this.minorVersion;
  }
  public visibility(val: boolean) {
    this.show = val;
  }

  public setOffset(offset: object) {
    this.offset = offset;
  }

  public getOffset() {
    return this.offset;
  }

  prepararLista(lista) {
    return lista.map(el => el.id);
  }

  public getMetaSave() {
    let obj = {
      id: this.id,
      categoriaID: this.categoriaID,
      isActive: this.isActive,
      htmlES: this.htmlES,
      htmlEN: this.htmlEN,
      htmlFR: this.htmlFR,
      listTags: this.prepararLista(this.tags),
      listMaterias: this.prepararLista(this.materias),
      listCursos: this.prepararLista(this.cursos),
      listAmbitos: this.prepararLista(this.ambitos),
      listEditores: []
    };
    return obj;
  }
}
